var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgMenuOutline = function SvgMenuOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 11H3a1 1 0 100 2h18a1 1 0 100-2zm0-7H3a1 1 0 000 2h18a1 1 0 100-2zM3 20h18a1 1 0 100-2H3a1 1 0 100 2z",
    fill: "#023F80"
  })));
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIxIDExSDNDMi40NDc3MiAxMSAyIDExLjQ0NzcgMiAxMkMyIDEyLjU1MjMgMi40NDc3MiAxMyAzIDEzSDIxQzIxLjU1MjMgMTMgMjIgMTIuNTUyMyAyMiAxMkMyMiAxMS40NDc3IDIxLjU1MjMgMTEgMjEgMTFaTTIxIDRIM0MyLjQ0NzcyIDQgMiA0LjQ0NzcyIDIgNUMyIDUuNTUyMjggMi40NDc3MiA2IDMgNkgyMUMyMS41NTIzIDYgMjIgNS41NTIyOCAyMiA1QzIyIDQuNDQ3NzIgMjEuNTUyMyA0IDIxIDRaTTMgMjBIMjFDMjEuNTUyMyAyMCAyMiAxOS41NTIzIDIyIDE5QzIyIDE4LjQ0NzcgMjEuNTUyMyAxOCAyMSAxOEgzQzIuNDQ3NzIgMTggMiAxOC40NDc3IDIgMTlDMiAxOS41NTIzIDIuNDQ3NzIgMjAgMyAyMFoiIGZpbGw9IiMwMjNGODAiLz4KPC9zdmc+Cg==";
export { SvgMenuOutline as ReactComponent };